import { SvgIcon } from '@mui/material';

const PaperlessInfographic = () => (
  <SvgIcon
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 80, height: 80, fill: 'none' }}
    data-testid="paperlessInfographicIcon"
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F8FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8103 15.3618H58.2937C60.3374 15.3618 61.9911 17.1277 61.9989 19.31V46.5282C59.8539 45.0926 57.2745 44.2553 54.4996 44.2553C47.0437 44.2553 40.9996 50.2995 40.9996 57.7553C40.9996 62.4339 43.3795 66.5566 46.9948 68.9788H22.8103C20.7667 68.9788 19.1052 67.2129 19.1052 65.0306V19.31C19.1052 17.1277 20.7667 15.3618 22.8103 15.3618Z"
      fill="#CFD2E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8103 17.3725H58.2937C59.1031 17.3725 59.9824 18.1109 59.9882 19.3141V45.4178C60.6923 45.7315 61.3646 46.1036 61.9989 46.5282V19.31C61.9911 17.1277 60.3374 15.3618 58.2937 15.3618H22.8103C20.7667 15.3618 19.1052 17.1277 19.1052 19.31V65.0306C19.1052 67.2129 20.7667 68.9788 22.8103 68.9788H46.9948C46.1314 68.4003 45.3385 67.7249 44.6317 66.9681H22.8103C21.9941 66.9681 21.1159 66.2232 21.1159 65.0306V19.31C21.1159 18.1174 21.9941 17.3725 22.8103 17.3725Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7048 10.2549H53.1882C55.2319 10.2549 56.8855 12.0207 56.8933 14.2031V44.4664C56.1163 44.3274 55.3163 44.2548 54.4993 44.2548C47.0435 44.2548 40.9993 50.299 40.9993 57.7548C40.9993 59.9567 41.5265 62.0355 42.4615 63.8719H17.7048C15.6611 63.8719 13.9997 62.106 13.9997 59.9237V14.2031C13.9997 12.0207 15.6611 10.2549 17.7048 10.2549Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1064 11.9532H51.7449C52.5351 11.9532 53.3934 12.6706 53.3991 13.8394V44.299C53.7619 44.2697 54.1288 44.2548 54.4991 44.2548C54.7889 44.2548 55.0766 44.2639 55.3618 44.2819V13.8354C55.3542 11.7154 53.74 10 51.7449 10H19.149C17.154 10 14.5108 11.7154 14.5108 13.8354V58.2497C14.5108 60.3697 16.1327 62.0851 18.1277 62.0851H41.7086C41.4949 61.4537 41.3267 60.8013 41.2077 60.1319H17.1064C16.3096 60.1319 15.4523 59.4082 15.4523 58.2497V13.8354C15.4523 12.6769 16.3096 11.9532 17.1064 11.9532Z"
      fill="#B6D6F7"
    />
    <g clipPath="url(#clip0_15801_175865)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.001 68.8337C60.9841 68.8337 65.8343 63.9834 65.8343 58.0003C65.8343 52.0172 60.9841 47.167 55.001 47.167C49.0179 47.167 44.1677 52.0172 44.1677 58.0003C44.1677 63.9834 49.0179 68.8337 55.001 68.8337Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.0011 67.0197C59.9823 67.0197 64.0204 62.9816 64.0204 58.0003C64.0204 53.0191 59.9823 48.9809 55.0011 48.9809C50.0198 48.9809 45.9817 53.0191 45.9817 58.0003C45.9817 62.9816 50.0198 67.0197 55.0011 67.0197ZM65.8344 58.0003C65.8344 63.9834 60.9841 68.8336 55.0011 68.8336C49.018 68.8336 44.1677 63.9834 44.1677 58.0003C44.1677 52.0172 49.018 47.167 55.0011 47.167C60.9841 47.167 65.8344 52.0172 65.8344 58.0003Z"
        fill="#00844D"
      />
      <g clipPath="url(#clip1_15801_175865)">
        <path
          d="M60.8534 52.8771C60.8436 52.7098 60.7727 52.552 60.6542 52.4336C60.5357 52.3151 60.3779 52.2442 60.2107 52.2344C57.9477 52.1015 55.9482 52.3678 54.2678 53.0266C52.6606 53.6567 51.4211 54.6338 50.6832 55.8521C49.6759 57.5152 49.6738 59.5349 50.6579 61.4625L49.6536 62.4668C49.527 62.5955 49.4564 62.7689 49.4572 62.9494C49.4579 63.1298 49.5299 63.3027 49.6575 63.4303C49.7851 63.5579 49.958 63.6299 50.1384 63.6307C50.3189 63.6314 50.4924 63.5608 50.621 63.4342L51.6253 62.43C52.5821 62.9184 53.5614 63.1645 54.5089 63.1645C55.4705 63.1674 56.4142 62.9044 57.2357 62.4046C58.454 61.6667 59.431 60.4272 60.0611 58.82C60.72 57.1396 60.9865 55.1402 60.8534 52.8771H60.8534ZM56.5269 61.2343C55.3777 61.9305 54.0265 61.9829 52.6533 61.402L57.4618 56.5934C57.5884 56.4647 57.659 56.2913 57.6582 56.1108C57.6575 55.9304 57.5855 55.7575 57.4579 55.6299C57.3303 55.5023 57.1574 55.4303 56.9769 55.4295C56.7965 55.4288 56.623 55.4994 56.4944 55.626L51.6858 60.4346C51.1049 59.0613 51.1574 57.7101 51.8534 56.5609C53.0489 54.5871 55.886 53.4903 59.5131 53.5747C59.5979 57.2011 58.5007 60.0389 56.5269 61.2344V61.2343Z"
          fill="#00844D"
        />
      </g>
    </g>
    <path
      d="M50.4754 24.166H21.3468C20.9544 24.166 20.6364 24.4841 20.6364 24.8765C20.6364 25.2689 20.9544 25.5869 21.3468 25.5869H50.4754C50.8678 25.5869 51.1859 25.2689 51.1859 24.8765C51.1859 24.4841 50.8678 24.166 50.4754 24.166Z"
      fill="#676C7D"
    />
    <path
      d="M41.1543 29.1392C41.1543 29.5316 40.8362 29.8496 40.4438 29.8496H39.5842C39.1918 29.8496 38.8737 29.5316 38.8737 29.1392C38.8737 28.7468 39.1918 28.4287 39.5842 28.4287H40.4438C40.8362 28.4287 41.1543 28.7468 41.1543 29.1392ZM36.5932 29.1392C36.5932 29.5316 36.2751 29.8496 35.8827 29.8496H35.0231C34.6307 29.8496 34.3126 29.5316 34.3126 29.1392C34.3126 28.7468 34.6307 28.4287 35.0231 28.4287H35.8827C36.2751 28.4287 36.5932 28.7468 36.5932 29.1392ZM32.0036 29.1392C32.0036 29.5316 31.6855 29.8496 31.2932 29.8496H30.4406C30.0483 29.8496 29.7302 29.5316 29.7302 29.1392C29.7302 28.7468 30.0483 28.4287 30.4406 28.4287H31.2932C31.6855 28.4287 32.0036 28.7468 32.0036 29.1392ZM27.4496 29.1392C27.4496 29.5316 27.1315 29.8496 26.7392 29.8496H25.8795C25.4871 29.8496 25.1691 29.5316 25.1691 29.1392C25.1691 28.7468 25.4871 28.4287 25.8795 28.4287H26.7392C27.1315 28.4287 27.4496 28.7468 27.4496 29.1392ZM22.9024 29.1534C22.8947 29.5402 22.5789 29.8496 22.1921 29.8496H21.3468C20.9544 29.8496 20.6364 29.5316 20.6364 29.1392C20.6364 28.7468 20.9544 28.4287 21.3468 28.4287H22.1921C22.59 28.4287 22.9104 28.7555 22.9024 29.1534Z"
      fill="#676C7D"
    />
    <path
      d="M35.5559 19.1914H21.3468C20.9544 19.1914 20.6364 19.5095 20.6364 19.9018C20.6364 20.2942 20.9544 20.6123 21.3468 20.6123H35.5559C35.9483 20.6123 36.2664 20.2942 36.2664 19.9018C36.2664 19.5095 35.9483 19.1914 35.5559 19.1914Z"
      fill="#676C7D"
    />
    <path
      d="M44.7943 33.4014H29.8748C29.4824 33.4014 29.1643 33.7194 29.1643 34.1118C29.1643 34.5042 29.4824 34.8223 29.8748 34.8223H44.7943C45.1867 34.8223 45.5048 34.5042 45.5048 34.1118C45.5048 33.7194 45.1867 33.4014 44.7943 33.4014Z"
      fill="#676C7D"
    />
    <path
      d="M24.1887 33.4014H21.3468C20.9544 33.4014 20.6364 33.7194 20.6364 34.1118C20.6364 34.5042 20.9544 34.8223 21.3468 34.8223H24.1887C24.5811 34.8223 24.8991 34.5042 24.8991 34.1118C24.8991 33.7194 24.5811 33.4014 24.1887 33.4014Z"
      fill="#676C7D"
    />
    <path
      d="M42.6605 38.374H21.3468C20.9544 38.374 20.6364 38.6921 20.6364 39.0845C20.6364 39.4768 20.9544 39.7949 21.3468 39.7949H42.6605C43.0528 39.7949 43.3709 39.4768 43.3709 39.0845C43.3709 38.6921 43.0528 38.374 42.6605 38.374Z"
      fill="#676C7D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7048 12.2655H53.1882C53.9976 12.2655 54.8769 13.004 54.8827 14.2072V44.2601C55.5668 44.2792 56.2383 44.3492 56.8933 44.4664V14.2031C56.8855 12.0207 55.2319 10.2549 53.1882 10.2549H17.7048C15.6611 10.2549 13.9997 12.0207 13.9997 14.2031V59.9237C13.9997 62.106 15.6611 63.8719 17.7048 63.8719H42.4615C42.1345 63.2296 41.8573 62.5577 41.6352 61.8613H17.7048C16.8886 61.8613 16.0103 61.1163 16.0103 59.9237V14.2031C16.0103 13.0105 16.8886 12.2655 17.7048 12.2655Z"
      fill="#4D5160"
    />
    <defs>
      <clipPath id="clip0_15801_175865">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(44.0001 47)"
        />
      </clipPath>
      <clipPath id="clip1_15801_175865">
        <rect
          width="11.7867"
          height="11.7867"
          fill="white"
          transform="translate(49.28 51.9336)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default PaperlessInfographic;
